import Lazy from './modules/lazy.js';
import Accordion from './components/accordion.js';

import '../styles/theme.scss';

new Lazy;
new Accordion;
